<template>
    <modal-dialog
        id="offsetting"
        :show.sync="shown"
    >
        <template v-slot:title>
            Schedule Shifter
        </template>

        <p>
            Shift project schedule forward or backward by a number of days or weeks.
            Dates landing on weekends will be shifted to workdays.<br/>
            (Use a negative value to move backwards)
        </p>
        <div class="uk-flex uk-flex-middle">
            <div class="uk-form-controls-text uk-margin-small-right">
                Shift by
            </div>
            <form-input
                type="number"
                name="count"
                :value="offset_data.count"
                format="0,0"
                :required="true"
                class="uk-flex-item-1"
                @input="change_offset_count"
            />
            <div class="uk-form-controls-text uk-margin-small-left">
                week(s)
            </div>
            <!--
            <div class="uk-button-group" data-uk-button-radio>
                <base-button
                    :class="{'uk-active': offset_data.unit === 'weeks'}"
                    @click.prevent="offset_data.unit = 'weeks'"
                >
                    weeks
                </base-button>
                <base-button
                    :class="{'uk-active': offset_data.unit !== 'weeks'}"
                    @click.prevent="offset_data.unit = 'days'"
                >
                    days
                </base-button>
            </div>
            //-->
        </div>

        <div v-if="!!record && !!offset_data.count" class="uk-grid uk-grid-small uk-margin-top">
            <div class="uk-width-2-5 uk-text-right">
                {{ record.computed_starts_at | nibnut.date("MMM DD, YYYY") }} to {{ record.computed_ends_at | nibnut.date("MMM DD, YYYY") }}
            </div>
            <div class="uk-width-1-5 uk-text-center">
                <open-icon glyph="forward" />
            </div>
            <div class="uk-width-2-5 uk-text-left">
                {{ offset_date(record.computed_starts_at) | nibnut.date("MMM DD, YYYY") }} to {{ offset_date(record.computed_ends_at) | nibnut.date("MMM DD, YYYY") }}
            </div>
        </div>

        <div class="uk-modal-footer uk-text-center">
            <base-button
                size="large"
                :disabled="!!offsetting"
                @click.prevent="close"
            >
                Cancel
            </base-button>
            <base-button
                size="large"
                color="primary"
                :disabled="!offset_data.count || !!offsetting"
                :waiting="offsetting"
                @click.prevent="offset"
            >
                {{ offset_by }}
            </base-button>
        </div>
    </modal-dialog>
</template>

<script>
import ModalDialog from "./ModalDialog/ModalDialog"
import FormInput from "../ui/FormInput"
import BaseButton from "../ui/BaseButton"
import OpenIcon from "../ui/OpenIcon"

export default {
    components: {
        ModalDialog,
        FormInput,
        BaseButton,
        OpenIcon
    },
    watch: {
        show: "reset"
    },
    methods: {
        reset () {
            if(this.show) {
                this.offset_data.count = 1
                this.offset_data.unit = "weeks"
            }
        },
        change_offset_count (value) {
            this.offset_data.count = parseInt(value) || 0
        },
        offset_date (date_string) {
            const date = this.$moment(date_string)
            return date.add(this.offset_data.count, this.offset_data.unit)
        },
        offset () {
            this.offsetting = true
            this.$store.dispatch("RECORD_ACTION", {
                entity: "project",
                id: this.record.id,
                action: "offset",
                data: { ...this.offset_data, relation_ids: ["phase", "task", "task_user"] },
                method: "post"
            }).then(() => {
                this.close()
            }).catch(error => {
                this.$error(error.message)
            }).then(() => {
                this.offsetting = false
            })
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        },
        offset_by () {
            if(this.offset_data.count) {
                const nb_days = Math.abs(this.offset_data.count)
                let message = "Move "
                if(this.offset_data.count < 0) {
                    if(nb_days === 1) {
                        if(this.offset_data.unit === "weeks") message += "back a week"
                        else message += "back a day"
                    } else message += "back "
                } else if(this.offset_data.count > 0) {
                    if(nb_days === 1) {
                        if(this.offset_data.unit === "weeks") message += "forward a week"
                        else message += "forward a day"
                    } else message += "forward "
                }
                if(nb_days > 1) message += this.nibnut_filter("nibnut.number", [nb_days, "0,0"]) + " " + this.offset_data.unit
                return message
            }
            return "Offset"
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        record: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            offset_data: {
                count: 1,
                unit: "weeks"
            },
            offsetting: false
        }
    }
}
</script>
